<template>
    <v-card class="pa-0 ma-0 trans-bkg" flat>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" class="px-1">
                        <v-text-field
                            v-model="item.label"
                            label="Label"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="px-1">
                        <v-select
                            v-model="item.status"
                            :items="meetingStatusList"
                            label="Status"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="showNonCalendlyDateTime">
                    <v-col cols="6" class="px-1">
                        <v-menu
                            ref="meetingDatePicker"
                            v-model="meetingDatePicker"
                            :close-on-content-click="false"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    id="psr_meeting_date_picker"
                                    label="Meeting Date"
                                    v-model="selectedMeetingDate"
                                    hint="Click the month to quickly change years"
                                    outlined
                                    persistent-hint
                                    prepend-icon="mdi-calendar"
                                    ref="input"
                                    v-on="on"
                                />
                            </template>
                            <v-date-picker
                                no-title
                                v-model="selectedMeetingDate"
                                @input="meetingDatePicker = false"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="6" class="px-1">
                        <v-select
                            v-model="selectedMeetingTime"
                            :items="Object.keys(startTimeItems).map(key => ({ value: key, text: startTimeItems[key]}))"
                            label="Meeting Time"
                            :persistent-hint="true"
                            hint="Time zone you are in"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="showNonCalendlyReason">
                    <v-col cols="12" class="px-1">
                        <v-textarea
                            v-model="item.non_calendly_reason"
                            label="Please provide a brief reason why this meeting is not being scheduled via Calendly."
                            outlined
                            required
                            :error-messages="nonCalendlyReasonError ? [nonCalendlyReasonError] : []"
                            @input="clearNonCalendlyReasonError"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end px-1">
            <!-- <v-btn
                color="primary"
                outlined
                @click="close"
            >
                Cancel
            </v-btn> -->
            <v-btn
                color="primary lighten-2 info--text"
                @click="save">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>


<script>
    import axios from 'axios';
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment';  
    import { 
        meetingStatusItems,
        startTimeItems
    } from '../helpers/constants';

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'UTC'
        });

    const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
        dateStyle: 'short',
        timeStyle: 'short'
    });

    export default {
        name: 'ProjectReportMeetingDialog',

        props: {
            editedItem: {
                type: Object
            },
            moduleData: {
                type: Object
            }
        },   

        computed: {
            item: {
                get() {
                    const { item = {} } = this.editedItem;

                    return {
                        ...item,
                        status: item.status || 'not_started'
                    };
                },

                set(value) {
                    this.editedItem.item = {
                        ...this.editedItem.item,
                        ...value
                    };
                }
            }, 

            showNonCalendlyReason: {
                get() {
                    return this.selectedMeetingTime && this.selectedMeetingDate && this.item.calendly_event_id === null;
                },
                set(value) {
                    this.showNonCalendlyReason = value;
                }
            },

            showNonCalendlyDateTime: {
                get() {
                    return this.item.calendly_event_id === null;
                },
                set(value) {
                    this.showNonCalendlyDateTime = value;
                }
            }

            // meetingDate: {
            //     get() {
            //         const { start_time } = this.item;
            //         return start_time;
            //     },

            //     set(value) {
            //         // console.log('meetingDate:', value);
            //         // value is a date in the format yyyy-mm-dd
            //         // previousDateTime is a date in the format yyyy-mm-ddThh:mm:ssZ
            //         const previousDateTime = this.item.start_time;
            //         // Generate a datetime in the format 2024-09-20T15:47:43.972Z
            //         // using value as the date and leaving the time
            //         let updatedDateTime;
                    
            //         if (previousDateTime) {
            //             const timeParts = previousDateTime.split('T');
            //             updatedDateTime = `${value}T${timeParts[1]}`;
            //         } else {
            //             updatedDateTime = `${value}T00:00:00Z`;
            //         }

            //         this.item = {
            //             ...this.item,
            //             start_time: updatedDateTime
            //         };
            //     }
            // },
        },

        data () {
            return {
                meetingDatePicker: false,
                meetingStatusList: Object.keys(meetingStatusItems).map(key => ({ value: key, text: meetingStatusItems[key]})),
                startTimeItems,
                showDateTimePicker: Cookie.get('levs') === 'root' ? true : false,
                selectedMeetingDate: '',
                selectedMeetingTime: '',
                nonCalendlyReasonError: '',
            }
        },

        watch: {
            editedItem: {
                handler(newVal) {
                    const startTime = newVal && newVal.item ? newVal.item.start_time : '';
                    this.selectedMeetingDate = this.extractDatePart(startTime);
                    this.selectedMeetingTime = this.extractTimePart(startTime);
                },
                immediate: true,
                deep: true
            }
        },

        methods: {
            extractDatePart (startTime) {
                if (!startTime) return '';

                const dateMatch = String(startTime).match(/^(\d{4}-\d{2}-\d{2})/);
                if (dateMatch && dateMatch[1]) return dateMatch[1];

                return this.formatMenuDate(startTime);
            },

            extractTimePart (startTime) {
                if (!startTime) return '';

                const timeMatch = String(startTime).match(/T(\d{2}:\d{2})/);
                return timeMatch && timeMatch[1] ? timeMatch[1] : '';
            },

            buildMeetingStartTime () {
                if (!this.selectedMeetingDate) {
                    return this.item.start_time || null;
                }

                const meetingTime = this.selectedMeetingTime || '00:00';
                return `${this.selectedMeetingDate}T${meetingTime}:00`;
            },

            formatMenuDate: function ( thisDate ) {
                if (!thisDate) return '';

                return new Date(thisDate).toISOString().split('T')[0]
            },

            getMinimumDate () {
                // "today" - nothing from today backwards
                const now = new Date();
                const year = String(now.getFullYear()).padStart(4, '0');
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const date = String(now.getDate()).padStart(2, '0');

                return `${year}-${month}-${date}`;
            },

            close () {
                this.$emit('close');
            },

            async save () {
                const didSave = await this.saveMeetingData();

                if (!didSave) {
                    return;
                }

                this.close();
                this.$emit('save', this.editedItem);
            },

            clearNonCalendlyReasonError () {
                if (this.nonCalendlyReasonError) {
                    this.nonCalendlyReasonError = '';
                }
            },

            saveMeetingData () {
                const { meeting_id, label, status, non_calendly_reason, project_id } = this.item;
                const trimmedReason = (non_calendly_reason || '').trim();

                this.clearNonCalendlyReasonError();

                if (this.showNonCalendlyReason && !trimmedReason) {
                    this.nonCalendlyReasonError = 'This field is required! It helps us understand the limitations of our scheduling process.';
                    return Promise.resolve(false);
                }
                
                const start_time = this.buildMeetingStartTime();
                let meetingSave; 

                if (meeting_id) {
                    // console.log(`Updating meeting with id ${meeting_id} ~ ${start_time}`);
                    meetingSave = axios.put(
                        `${appUrls.api}/api/admin/meeting/${meeting_id}`,
                        {
                            label,
                            start_time,
                            status,
                            non_calendly_reason: trimmedReason
                        },
                        {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        }
                    );
                } else {
                    meetingSave = axios.post(
                        `${appUrls.api}/api/project/${project_id}/meeting`,
                        {
                            label,
                            start_time,
                            status,
                            non_calendly_reason: trimmedReason
                        },
                        {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                        }
                    );
                }
                
                return meetingSave.then(() => true);
            }
        }
    }
</script>

<style scoped>
    .trans-bkg {
        background-color: transparent !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectReportMeetingDialog.vue